import {targets, useReferentialContext} from "../../Context";
import React, {SetStateAction, useEffect, useState} from "react";
import dayjs from "dayjs";
import WindowContainer from "../../components/layout/WindowContainer";
import FilterSet from "../../components/selectors/Filterset";
import {capitalize, Grid, Stack} from "@mui/material";
import WeaponIcon from "../../components/Icons/WeaponIcon";
import {StatInVerticalStack, Title} from "../../NeonComponents/Texts";
import {NeonCard, NeonCardContent, NeonCardHeader} from "../../NeonComponents/NeonCards";
import {scrollable} from "../../theme";
import {AnimatePresence, motion} from "framer-motion";
import Box from "@mui/material/Box";
import formatters from "../../NeonComponents/Formatters";
import {NeonDivider} from "../../NeonComponents/NeonOthers";
import TeamIcon from "../../components/Icons/TeamIcon";


export default function CompetitiveTeamDrafts() {
    const ctx = useReferentialContext();
    const [team, setTeam] = useState(ctx.selectedTeam);
    const [from, setFrom] = useState(dayjs(`${dayjs().year()}-01-01`));
    const [until, setUntil] = useState(dayjs());

    const [paramObject, setParamObject] = useState<any>({});


    return <WindowContainer spacing={1}>
        <FilterSet paramObject={paramObject} setParamObject={setParamObject} target={targets.competitive} team={team} setTeam={setTeam} date__gte={from} setDateGte={setFrom}
        date__lt={until} setDateLt={setUntil}/>
        <Grid container spacing={1} columns={15}>
            <Grid size={3}>
                <PicksStats paramObject={paramObject}/>
            </Grid>
            <Grid size={3}>
                <PicksVsStats paramObject={paramObject}/>
            </Grid>
            <Grid size={3}>
                <BansStats paramObject={paramObject}/>
            </Grid>
            <Grid size={3}>
                <BansVsStats paramObject={paramObject}/>
            </Grid>
            <Grid size={3}>
                <DecidersStats paramObject={paramObject}/>
            </Grid>

        </Grid>
    </WindowContainer>
}

interface StatsBlockProps {
  stats: any; // Use specific type if you have one
  title?: React.ReactNode;
  decoration?: React.ReactNode;
  selected: boolean
    onClick : () => void
}

const StatsBlock: React.FC<StatsBlockProps> = ({ stats, title, decoration, selected, onClick }) => {
    return <Box sx={{width:'100%',minWidth:'100%',alignItems:'center', justifyContent:'center', display:'flex',
        // border:'1px solid pink',
        }}>
    <Grid onClick={onClick} container columns={4} spacing={1} sx={{
        width:'90%',
        minWidth: '90%',
        transform: "scale(1)", // initial state
        transition: "transform 0.3s ease-in-out", // always applied
        "&::before": selected
            ? {
                content: "''",
                position: "absolute",
                top: "15%",
                bottom: "15%",
                left: "0px",
                width: "1px",
                height: "70%",
                background: "#ffffff",
                boxShadow: `0px 0px 5px #fff, 0px 0px 20px #fff`,
              }
            : {},}}>
            <Grid size={1.5} sx={{alignItems:'center', justifyContent:'center', display:'flex'}}>
                {title}
            </Grid>
            <Grid size={2.5} sx={{alignItems:'center', justifyContent:'center', display:'flex'}}>
                {decoration}
            </Grid>
            <Grid size={1}><StatInVerticalStack label={'Series'} value={stats.series__cnt} format={formatters.integer}/></Grid>
            <Grid size={3}>
                <Stack direction={'row'} spacing={1} sx={{alignItems:'center', justifyContent:'center', display:'flex', width:'100%'}}>{
                (stats.vs_teams ? stats.vs_teams : stats.by_teams).split(',').map((t: string) => <TeamIcon team_name={t}/>)
            }</Stack></Grid>
            <NeonDivider/>
        </Grid>
        </Box>
}

function PicksStats(props: {paramObject: any}){
    const ctx = useReferentialContext();
    const [picks, setPicks] = useState<any[]>([]);
    useEffect(() => {
        if(props.paramObject.watermark){
            ctx.reckonApi.competitiveDraftSlots.aggregate({type:'pick', ...props.paramObject, groupby: ['map'], aggregates: ['series__cnt'], ordering: '-series__cnt', metrics: ['vs_teams']}).then(setPicks);
        }
    }, [props.paramObject.watermark]);
    const statsBlock = (stats: any) => {
        return <StatsBlock onClick={() => false} stats={stats} title={<Title>{capitalize(stats.map)}</Title>} decoration={<Title>{capitalize(stats.map)}</Title>} selected={false}/>
    }

    return <NeonCard sx={{width:'100%', height:'100%'}}>
        <NeonCardHeader title={'Picks'}/>
        <NeonCardContent sx={{height:'100%', width:'100%', flexDirection:'column',
                    alignItems:'flex-start', justifyContent:'flex-start'}}>
            <Stack direction={'column'} spacing={1}
                        sx={{
                            alignItems: "center",
                            justifyContent: "flex-start",
                            display: "flex",
                            width: "100%",
                            height:'90%',
                            ...scrollable,
                            '&::-webkit-scrollbar:horizontal': {
                              display: 'none',        // hide horizontal scrollbar in WebKit
                            },
                        }}
                    >
                <AnimatePresence mode="popLayout">
            {
                picks.map((r, index) => <motion.div
                    key={`pick-${r.map}`}
                    layoutId={`pick-${r.map}`}
                    layout
                    style={{width:'100%'}}
                    initial={{opacity: 0, y: 10}}
                    animate={{opacity: 1, y: 0}}
                    exit={{opacity: 0, y: -10}}
                    transition={{duration: 0.3}}
                >{statsBlock(r)}</motion.div>)
            }
            </AnimatePresence>
            </Stack>
        </NeonCardContent>
    </NeonCard>
}

function BansStats(props: {paramObject: any}){
    const ctx = useReferentialContext();
    const [picks, setPicks] = useState<any[]>([]);
    useEffect(() => {
        if(props.paramObject.watermark){
            ctx.reckonApi.competitiveDraftSlots.aggregate({type:'ban', ...props.paramObject, groupby: ['map'], aggregates: ['series__cnt'], ordering: '-series__cnt', metrics: ['vs_teams']}).then(setPicks);
        }
    }, [props.paramObject.watermark]);
    const statsBlock = (stats: any) => {
        return <StatsBlock onClick={() => false} stats={stats} title={<Title>{capitalize(stats.map)}</Title>} decoration={<Title>{capitalize(stats.map)}</Title>} selected={false}/>
    }

    return <NeonCard sx={{width:'100%', height:'100%'}}>
        <NeonCardHeader title={'Bans'}/>
        <NeonCardContent sx={{height:'100%', width:'100%', flexDirection:'column',
                    alignItems:'flex-start', justifyContent:'flex-start'}}>
            <Stack direction={'column'} spacing={1}
                        sx={{
                            alignItems: "center",
                            justifyContent: "flex-start",
                            display: "flex",
                            width: "100%",
                            height:'90%',
                            ...scrollable,
                            '&::-webkit-scrollbar:horizontal': {
                              display: 'none',        // hide horizontal scrollbar in WebKit
                            },
                        }}
                    >
                <AnimatePresence mode="popLayout">
            {
                picks.map((r, index) => <motion.div
                    key={`ban-${r.map}`}
                    layoutId={`ban-${r.map}`}
                    layout
                    style={{width:'100%'}}
                    initial={{opacity: 0, y: 10}}
                    animate={{opacity: 1, y: 0}}
                    exit={{opacity: 0, y: -10}}
                    transition={{duration: 0.3}}
                >{statsBlock(r)}</motion.div>)
            }
            </AnimatePresence>
            </Stack>
        </NeonCardContent>
    </NeonCard>
}

function BansVsStats(props: {paramObject: any}){
    const ctx = useReferentialContext();
    const [picks, setPicks] = useState<any[]>([]);
    useEffect(() => {
        if(props.paramObject.watermark){
            ctx.reckonApi.competitiveDraftSlots.aggregate({type:'ban', ...props.paramObject, team1: undefined, team2: props.paramObject.team1, groupby: ['map'], aggregates: ['series__cnt'], ordering: '-series__cnt', metrics: ['by_teams']}).then(setPicks);
        }
    }, [props.paramObject.watermark]);
    const statsBlock = (stats: any) => {
        return <StatsBlock onClick={() => false} stats={stats} title={<Title>{capitalize(stats.map)}</Title>} decoration={<Title>{capitalize(stats.map)}</Title>} selected={false}/>
    }

    return <NeonCard sx={{width:'100%', height:'100%'}}>
        <NeonCardHeader title={'Bans VS'}/>
        <NeonCardContent sx={{height:'100%', width:'100%', flexDirection:'column',
                    alignItems:'flex-start', justifyContent:'flex-start'}}>
            <Stack direction={'column'} spacing={1}
                        sx={{
                            // border:'1px solid red',
                            alignItems: "center",
                            justifyContent: "flex-start",
                            display: "flex",
                            width: "100%",
                            height:'90%',
                            ...scrollable,
                            '&::-webkit-scrollbar:horizontal': {
                              display: 'none',        // hide horizontal scrollbar in WebKit
                            },
                        }}
                    >
                <AnimatePresence mode="popLayout">
            {
                picks.map((r, index) => <motion.div
                    key={`bansvs-${r.map}`}
                    layoutId={`bansvs-${r.map}`}
                    layout
                    style={{width:'100%'}}
                    initial={{opacity: 0, y: 10}}
                    animate={{opacity: 1, y: 0}}
                    exit={{opacity: 0, y: -10}}
                    transition={{duration: 0.3}}
                >{statsBlock(r)}</motion.div>)
            }
            </AnimatePresence>
            </Stack>
        </NeonCardContent>
    </NeonCard>
}

function PicksVsStats(props: {paramObject: any}){
    const ctx = useReferentialContext();
    const [picks, setPicks] = useState<any[]>([]);
    useEffect(() => {
        if(props.paramObject.watermark){
            ctx.reckonApi.competitiveDraftSlots.aggregate({type:'pick', ...props.paramObject, team1: undefined, team2: props.paramObject.team1, groupby: ['map'], aggregates: ['series__cnt'], ordering: '-series__cnt', metrics: ['by_teams']}).then(setPicks);
        }
    }, [props.paramObject.watermark]);
    const statsBlock = (stats: any) => {
        return <StatsBlock onClick={() => false} stats={stats} title={<Title>{capitalize(stats.map)}</Title>} decoration={<Title>{capitalize(stats.map)}</Title>} selected={false}/>
    }

    return <NeonCard sx={{width:'100%', height:'100%'}}>
        <NeonCardHeader title={'Picks VS'}/>
        <NeonCardContent sx={{height:'100%', width:'100%', flexDirection:'column',
                    alignItems:'flex-start', justifyContent:'flex-start'}}>
            <Stack direction={'column'} spacing={1}
                        sx={{
                            // border:'1px solid red',
                            alignItems: "center",
                            justifyContent: "flex-start",
                            display: "flex",
                            width: "100%",
                            height:'90%',
                            ...scrollable,
                            '&::-webkit-scrollbar:horizontal': {
                              display: 'none',        // hide horizontal scrollbar in WebKit
                            },
                        }}
                    >
                <AnimatePresence mode="popLayout">
            {
                picks.map((r, index) => <motion.div
                    key={`picksvs-${r.map}`}
                    layoutId={`picksvs-${r.map}`}
                    layout
                    style={{width:'100%'}}
                    initial={{opacity: 0, y: 10}}
                    animate={{opacity: 1, y: 0}}
                    exit={{opacity: 0, y: -10}}
                    transition={{duration: 0.3}}
                >{statsBlock(r)}</motion.div>)
            }
            </AnimatePresence>
            </Stack>
        </NeonCardContent>
    </NeonCard>
}

function DecidersStats(props: {paramObject: any}){
    const ctx = useReferentialContext();
    const [picks, setPicks] = useState<any[]>([]);
    useEffect(() => {
        if(props.paramObject.watermark){
            ctx.reckonApi.competitiveDraftSlots.aggregate({type:'decider', ...props.paramObject, team1: undefined, teams: props.paramObject.team1, groupby: ['map'], aggregates: ['series__cnt'], ordering: '-series__cnt', metrics: ['vs_teams']}).then(setPicks);
        }
    }, [props.paramObject.watermark]);
    const statsBlock = (stats: any) => {
        return <StatsBlock onClick={() => false} stats={stats} title={<Title>{capitalize(stats.map)}</Title>} decoration={<Title>{capitalize(stats.map)}</Title>} selected={false}/>
    }

    return <NeonCard sx={{width:'100%', height:'100%'}}>
        <NeonCardHeader title={'Deciders'}/>
        <NeonCardContent sx={{height:'100%', width:'100%', flexDirection:'column',
                    alignItems:'flex-start', justifyContent:'flex-start'}}>
            <Stack direction={'column'} spacing={1}
                        sx={{
                            alignItems: "center",
                            justifyContent: "flex-start",
                            display: "flex",
                            width: "100%",
                            height:'90%',
                            ...scrollable,
                            '&::-webkit-scrollbar:horizontal': {
                              display: 'none',        // hide horizontal scrollbar in WebKit
                            },
                        }}
                    >
                <AnimatePresence mode="popLayout">
            {
                picks.map((r, index) => <motion.div
                    key={`decidervs-${r.map}`}
                    layoutId={`decidervs-${r.map}`}
                    layout
                    style={{width:'100%'}}
                    initial={{opacity: 0, y: 10}}
                    animate={{opacity: 1, y: 0}}
                    exit={{opacity: 0, y: -10}}
                    transition={{duration: 0.3}}
                >{statsBlock(r)}</motion.div>)
            }
            </AnimatePresence>
            </Stack>
        </NeonCardContent>
    </NeonCard>
}

